var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"static-view-heading d-none d-md-flex"},[_c('span',{staticClass:"static-view-heading__icon"},[_c('AppIcon',{attrs:{"name":_vm.icon}})],1),_c('p',[_vm._v(_vm._s(_vm.subtitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }